(() => {
  const init = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const reopen = root.parentElement.querySelector('[data-fc-cookie-reopen]');
    const status = root.querySelector('[role="status"]');
    const buttons = root.querySelectorAll('[data-consent]');
    let api;
    let loading;
    const getApi = () => {
      if (window.Shopify && window.Shopify.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
      if (loading) return loading;
      loading = new Promise((resolve, reject) => {
        if (!window.Shopify || !window.Shopify.loadFeatures) return reject(new Error('Unavailable'));
        window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], (error) => {
          if (error || !window.Shopify.customerPrivacy) reject(error || new Error('Unavailable'));
          else resolve(window.Shopify.customerPrivacy);
        });
      }).catch(error => {loading = null;throw error;});
      return loading;
    };
    const show = () => {
      root.hidden = false;
      if (reopen) reopen.hidden = true;
      if (api) {
        const consent = api.currentVisitorConsent();
        root.querySelectorAll('input[type="checkbox"]').forEach(input => {input.checked = consent[input.name] === 'yes';});
      }
    };
    const hide = () => {root.hidden = true;if(reopen) reopen.hidden = false;};
    if (reopen) reopen.addEventListener('click', show);
    buttons.forEach(button => button.addEventListener('click', async () => {
      status.textContent = '';
      buttons.forEach(el => {el.disabled = true;});
      try {
        api = await getApi();
        const choice = {};
        ['analytics','marketing','preferences'].forEach(key => {
          choice[key] = button.dataset.consent === 'save' ? root.querySelector('[name="'+key+'"]').checked : button.dataset.consent === 'accept';
        });
        await new Promise((resolve,reject) => {
          const timeout = setTimeout(() => reject(new Error('Timeout')),10000);
          api.setTrackingConsent(choice, result => {clearTimeout(timeout);if(result && result.error) reject(new Error(result.error));else resolve();});
        });
        hide();
      } catch(error) {status.textContent = root.dataset.error;}
      finally {buttons.forEach(el => {el.disabled = false;});}
    }));
    getApi().then(privacy => {
      api = privacy;
      const consent = api.currentVisitorConsent();
      const known = ['analytics','marketing','preferences'].every(key => consent[key] === 'yes' || consent[key] === 'no');
      if (!known || root.dataset.editor === 'true') show();else hide();
    }).catch(show);
    document.addEventListener('shopify:section:select', event => {if(event.target.contains(root)) show();});
  };
  document.querySelectorAll('[data-fc-cookie]').forEach(init);
  if (!window.fellauraCookieSectionListener) {
    window.fellauraCookieSectionListener = true;
    document.addEventListener('shopify:section:load', event => {event.target.querySelectorAll('[data-fc-cookie]').forEach(init);});
  }
})();
